import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { PrimaryColors } from 'src/types/globalTypes';

const InputDiv = styled.div<{
  primaryColors?: PrimaryColors;
  isCustomized: boolean;
  width?: string;
  isBigForm?: boolean;
}>`
  position: relative;
  width: ${(props) => props.width};
  input {
    width: 100%;
    height: ${(props) => (props.isBigForm ? '57px' : '40px')};
    border: 1px solid
      ${(props) => (props.primaryColors ? props.primaryColors.third : colors.primaryBlue_100)};
    border-radius: 4px;
    padding: ${(props) => (props.isCustomized ? '25px 12px 8px 12px' : '12px 12px')};
    background-color: ${colors.white};

    :disabled {
      background-color: ${colors.BlueGray_200};
    }
    :focus {
      outline: none;
      border: 1px solid
        ${(props) => (props.primaryColors ? props.primaryColors.seventh : colors.primaryBlue_500)};
    }
    ::placeholder {
      color: ${colors.BlueGray_200};
    }
  }
  span {
    position: absolute;
    pointer-events: none;
    left: 15px;
    top: -2px;
    font-size: 12px;
    color: ${colors.BlueGray_500};
    span {
      position: absolute;
      pointer-events: none;
      left: 0px;
      top: 20px;
      font-size: 16px;
      color: ${colors.BlueGray_200};
      width: max-content;
    }
  }
`;

interface IProps {
  value?: string;
  onChange: React.Dispatch<React.SetStateAction<string>>;
  width?: string;
  primaryColors?: PrimaryColors;
  placeholder?: string;
  customizedTitle?: string;
  isBigForm?: boolean;
  maxLength?: number;
  inputId?: string;
  ariaLabel?: string;
}

const Input: React.FC<IProps> = (props) => {
  return (
    <InputDiv
      isCustomized={!!props.customizedTitle}
      primaryColors={props.primaryColors}
      width={props.width}
      isBigForm={props.isBigForm}
    >
	    <input
	      value={props.value}
	      placeholder={props.placeholder}
	      onChange={(e) => {
	        props.onChange(e.target.value);
	      }}
	      maxLength={props.maxLength}
		  id={props.inputId}
		  aria-label={props.ariaLabel}
	    />
      <span>{props.customizedTitle}</span>
    </InputDiv>
  );
};

export default Input;
